import { render, staticRenderFns } from "./PushRecordList.vue?vue&type=template&id=345aa496&scoped=true&"
import script from "./PushRecordList.vue?vue&type=script&lang=js&"
export * from "./PushRecordList.vue?vue&type=script&lang=js&"
import style0 from "./PushRecordList.vue?vue&type=style&index=0&id=345aa496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345aa496",
  null
  
)

export default component.exports